export const computeProcessIcon = (name: string) =>
  ({
    // Process families
    Additive: 'manufacturing-additive',
    Subtractive: 'manufacturing-substractive',
    Forming: 'manufacturing-forming',
    Cutting: 'manufacturing-cutting',
    Molding: 'manufacturing-molding',
  })[name] || 'cog';
